import { PaperPlaneTilt, X } from "@phosphor-icons/react";
import { ProductSelect } from "../ProductSelect";

export const DispatchPanel = ({ items, setItem, addItem, removeItem, products, isAdmin, onDispatch, saving }) => (
  <div className="rounded-md border border-amber-300 bg-amber-50/60 p-5" data-testid="dispatch-panel">
    <h2 className="flex items-center gap-2 text-base font-bold text-slate-900 md:text-lg">
      <PaperPlaneTilt size={18} weight="duotone" /> Dispatch This Order
    </h2>
    <p className="mt-1 text-xs text-slate-500">
      Confirm the actual quantities being dispatched. Add a line item if needed, and fill dispatch details (left panel) including driver mobile.
    </p>
    <div className="mt-3 space-y-2">
      {items.map((it, i) => (
        <div key={it._key} className="flex items-center gap-2">
          <div className="min-w-0 flex-1 [&>button]:mt-0 [&>button]:bg-white">
            <ProductSelect products={products} value={it.product_name} testId={`dispatch-item-product-${i}`}
              allowCustom={isAdmin} placeholder="Product"
              onChange={(v) => setItem(i, "product_name", v)} />
          </div>
          <input data-testid={`dispatch-item-qty-${i}`} type="number" min="0" step="any" value={it.quantity}
            onChange={(e) => setItem(i, "quantity", e.target.value)} placeholder="Qty"
            className="w-20 rounded-md border border-slate-300 bg-white px-2 py-2 text-right font-mono text-sm outline-none transition-colors duration-150 focus:border-slate-900" />
          {items.length > 1 && (
            <button data-testid={`dispatch-item-remove-${i}`} onClick={() => removeItem(i)}
              className="text-slate-400 transition-colors duration-150 hover:text-red-600">
              <X size={15} />
            </button>
          )}
        </div>
      ))}
    </div>
    <button type="button" data-testid="dispatch-add-item-button" onClick={addItem}
      className="mt-2 text-sm font-medium text-slate-600 underline-offset-4 hover:underline">
      + Add line item
    </button>
    <button data-testid="dispatch-order-button" onClick={onDispatch} disabled={saving}
      className="mt-3 flex w-full items-center justify-center gap-2 rounded-md bg-amber-600 px-4 py-2.5 text-sm font-semibold text-white transition-colors duration-150 hover:bg-amber-700 disabled:opacity-60">
      <PaperPlaneTilt size={16} weight="bold" />
      {saving ? "Dispatching…" : "Dispatch Order"}
    </button>
  </div>
);
